var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLens = function SvgLens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.898 12.296a5.898 5.898 0 1 1 4.807-2.48l4.007 4.006a.983.983 0 1 1-1.39 1.39l-4.007-4.007a5.87 5.87 0 0 1-3.417 1.09Zm0-1.376a4.522 4.522 0 1 0 0-9.044 4.522 4.522 0 0 0 0 9.044Z",
    clipRule: "evenodd"
  })));
};
export { SvgLens as ReactComponent };
export default __webpack_public_path__ + "81b63596df8986c9acc3b6eab5238019.svg";